module.exports = __webpack_public_path__ + "img/red.f9841afc.jpg";